import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { areRequiredSubFieldsFilled, convertFormFieldType } from "../../utils";
import type { FormFieldNode, NextFieldLogicOptions } from "../../utils/types";
import type { LocalTellescopeFormResponseMap } from "../use-tellescope-form-core";

export interface IsNextDisabledArgs {
  activeField: FormFieldNode | undefined;
  fieldsMap: Record<string, TellescopeModelFromName<"form_fields">>;
  currentResponses: LocalTellescopeFormResponseMap;
  fieldErrors: Record<string, string | null>;
  repeatMismatchFieldIds: Set<string>;
  logicOptions: NextFieldLogicOptions;
  isFieldValueValid: (fieldId: string) => boolean;
}

export const isNextDisabled = ({
  activeField,
  fieldsMap,
  currentResponses,
  fieldErrors,
  repeatMismatchFieldIds,
  logicOptions,
  isFieldValueValid,
}: IsNextDisabledArgs): boolean => {
  if (!activeField) return true;
  if (convertFormFieldType(activeField.value.type) === null) return false;
  if (repeatMismatchFieldIds.has(activeField.value.id)) return true;
  if (fieldErrors[activeField.value.id]) return true;

  if (activeField.value.type === "Question Group") {
    const allRequiredSubFieldsFilled = areRequiredSubFieldsFilled({
      group: activeField.value,
      fieldsMap,
      responsesByFieldId: currentResponses,
      allResponses: Object.values(currentResponses),
      repeatMismatchFieldIds,
      logicOptions,
    });
    if (!allRequiredSubFieldsFilled) return true;
  } else if (!activeField.value.isOptional) {
    if (!isFieldValueValid(activeField.value.id)) return true;
  }

  return false;
};
